import React from 'react'
import { Link } from 'react-router-dom'
import { theBasics, lookAndFeel, advanced, articleLookup, HELP_SKILL_GATE } from 'constants/Settings'
import { hasGates } from 'utils/access'

import cx from 'classnames'

import './style.css'

const SettingsNav = ({ match }) => {
  const page = match.params.settingPage
  
  const onTheBasics = page === theBasics
  const onLookAndFeel = page === lookAndFeel
  const onAdvanced = page === advanced
  const onArticleLookup =  page === articleLookup
  
  return (
    <div className="settings-nav-wrapper">
      <div className={cx('settings-nav-item-wrapper', {
        selected: onTheBasics
      })}>
        <Link
          className={cx('settings-nav-item', {
            selected: onTheBasics
          })}
          to="/settings/the-basics"
        >
          The Basics
        </Link>
      </div>
      
      <div className={cx('settings-nav-item-wrapper', {
        selected: onLookAndFeel
      })}>
        <Link
          className={cx('settings-nav-item', {
            selected: onLookAndFeel
          })}
          to="/settings/look-and-feel"
        >
          Look and Feel
        </Link>
      </div>

      {hasGates(HELP_SKILL_GATE) &&
        <div className={cx('settings-nav-item-wrapper', {
          selected: onArticleLookup
        })}>
          <Link
            className={cx('settings-nav-item', {
              selected: onArticleLookup
            })}
            to="/settings/lookup"
          >
            Article Lookup
          </Link>
        </div>
      }
      
      <div className={cx('settings-nav-item-wrapper', {
        selected: onAdvanced
      })}>
        <Link
          className={cx('settings-nav-item', {
            selected: onAdvanced
          })}
          to="/settings/advanced"
        >
          Advanced
        </Link>
      </div>
    </div>
)}

export default SettingsNav